import { useGetViewupSnsAccounts } from 'Shared/hooks/api';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { useGlobalModalStore } from 'app/_hook';
import { useRouter } from 'next/navigation';
import { AccountMenuButton } from '../OffViewingButton';

export const AutoEarningSettingButton = () => {
  const router = useRouter();

  const { data: getViewingAccounts } = useGetViewupSnsAccounts();
  const hasViewingAccount = (getViewingAccounts?.data.length || 0) > 0;

  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  const handleClickThis = () => {
    Analytics.getInstance().track('VIEWING_OFF_MENU', { type: 'auto' });
    if (hasViewingAccount) {
      router.push(LINK.ACCOUNT_AUTO);
      return;
    }

    setAlertModal({
      actionButtonText: '계정 추가하기',
      content: `보너스뷰업으로 설정할 수 있는\n계정이 없어요.`,
      onClickActionButton: () => {
        router.push(LINK.ACCOUNT_ADD);
      },
      title: '계정을 추가해 주세요.',
    });
  };

  return (
    <AccountMenuButton
      content={`뷰업을 이용하지 않아도 적립된다면?`}
      onClick={handleClickThis}
      title={'자동 보너스 활동'}
    />
  );
};
